import { KoAPI } from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;

export const B2CAPI = {
  getByIdSettings(id) {
    return KoAPI.get(`/api/${version}/admin/settings/${id}`);
  },
  verifyOtp(data){
    return KoAPI.get(`/api/${version}/admin/customer/${data?.accountId}/${data?.customer}/${data?.otp}`);
  },
  getValidateEmail(data){
    return KoAPI.post(`/api/${version}/workspace/send/otp`, { data });
  },
  validateUsers(query, accountId) {
    return KoAPI.get(`/api/${version}/admin/customer/validate/${accountId}`, { query: { ...query } });
  },
  createUsers(query) {
    return KoAPI.post(`/api/${version}/admin/public/customer`, { data: { ...query } });
  }
};